'use client';

import { Stack } from '@mantine/core';
import ChatAttachmentComposer from './chat-attachment-composer';
import { ChatComposerProvider } from './chat-composer-provider';
import ChatMessageComposer, {
  IChatMessageComposerProps,
} from './chat-message-composer';

interface IChatComposerProps extends IChatMessageComposerProps {
  size?: 'sm' | 'md';
}

export default function ChatComposer({
  size = 'md',
  onSendMessage,
  isSendingMessage = false,
  supportedFileUploads = ['image', 'file', 'video'],
  captureMode,
  selectedConversationId,
  isDisabled = false,
  preserveContentOnConversationChange = false,
}: IChatComposerProps) {
  return (
    <ChatComposerProvider>
      <Stack gap={0}>
        <ChatAttachmentComposer size={size} />
        <ChatMessageComposer
          size={size}
          supportedFileUploads={supportedFileUploads}
          onSendMessage={onSendMessage}
          isSendingMessage={isSendingMessage}
          captureMode={captureMode}
          isDisabled={isDisabled}
          selectedConversationId={selectedConversationId}
          preserveContentOnConversationChange={
            preserveContentOnConversationChange
          }
        />
      </Stack>
    </ChatComposerProvider>
  );
}
